// src/components/Header.js
import React, { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../assets/img/logo2.png";
import iconOpen from "../assets/img/X.svg";
import iconClosed from "../assets/img/4.svg";

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [ignoreScroll, setIgnoreScroll] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const navbarRef = useRef(null);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
    setIgnoreScroll(true);
    setTimeout(() => setIgnoreScroll(false), 400);
  };

  const handleLinkClick = () => {
    if (isMenuOpen) toggleMenu();
  };

  const handleScroll = () => {
    if (ignoreScroll || isMenuOpen || !navbarRef.current) return;

    if (window.innerWidth < 768) return;

    const currentScrollTop =
      window.pageYOffset || document.documentElement.scrollTop;

    if (Math.abs(currentScrollTop - lastScrollTop) > 150) {
      navbarRef.current.classList.toggle(
        "hidden",
        currentScrollTop > lastScrollTop
      );
      setLastScrollTop(currentScrollTop);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  });

  return (
    <nav
      className="navbar navbar-light navbar-expand-md fixed-top"
      ref={navbarRef}
      id="scrollNavbar"
    >
      <div className="container-fluid">
        <NavLink
          className="navbar-brand d-md-none"
          to="/"
          onClick={handleLinkClick}
        >
          <img src={logo} alt="Your Logo" height="40" />
        </NavLink>
        <button
          className="navbar-toggler"
          onClick={toggleMenu}
          style={{
            borderRadius: "50%",
            outline: "none",
            backgroundImage: `url(${isMenuOpen ? iconOpen : iconClosed})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            width: "40px",
            height: "40px",
            border: "1px solid rgba(0, 0, 0, 0.3)",
          }}
        />
        <div
          className={`custom-collapse navbar-collapse justify-content-center ${
            isMenuOpen ? "show" : ""
          }`}
          id="navcol-1"
        >
          <div className="d-flex align-items-center">
            <NavLink
              className="navbar-brand d-none d-md-block me-4"
              to="/"
              onClick={handleLinkClick}
            >
              <img src={logo} alt="Your Logo" height="40" />
            </NavLink>
            <ul className="navbar-nav" onClick={handleLinkClick}>
              {[
                { to: "/", label: "Home" },
                { to: "/work", label: "Work" },
                { to: "/services", label: "Services" },
                { to: "/about", label: "About" },
                { to: "/contact", label: "Contact" },
                { to: "/subscribe", label: "Subscribe", gradient: true },
              ].map(({ to, label, gradient }) => (
                <li className="nav-item" key={label}>
                  <NavLink
                    className={({ isActive }) =>
                      `nav-link ${isActive ? "active" : ""} ${
                        gradient ? "gradient-navbar" : ""
                      }`
                    }
                    to={to}
                  >
                    {label}
                  </NavLink>
                </li>
              ))}

              {/* 
<li className="nav-item">
  <NavLink className="nav-link" to="/search">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icon-tabler-search"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <circle cx="10" cy="10" r="7" />
      <line x1="21" y1="21" x2="15" y2="15" />
    </svg>
  </NavLink>
</li>
*/}
              <li className="nav-item d-flex align-items-center">
                <a
                  href="https://dashboard.hobstudio.tv/login"
                  className="login-icon-link"
                  aria-label="Login"
                >
                  {/* Icon — desktop only */}
                  <svg
                    className="d-none d-md-block"
                    height="512"
                    viewBox="0 0 512 512"
                    width="512"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="ARROW_48" data-name="ARROW 48">
                      <path d="m400.14.16h-218.79a82 82 0 0 0 -81.9 81.9v50.54a24 24 0 1 0 48 0v-50.54a33.94 33.94 0 0 1 33.9-33.9h218.79a33.93 33.93 0 0 1 33.86 33.9v347.88a33.93 33.93 0 0 1 -33.89 33.9h-218.76a33.94 33.94 0 0 1 -33.9-33.9v-58.47a24 24 0 0 0 -48 0v58.47a82 82 0 0 0 81.9 81.9h218.79a82 82 0 0 0 81.86-81.9v-347.88a82 82 0 0 0 -81.86-81.9z" />
                      <path d="m364.64 238.53-85.4-85.35a24 24 0 0 0 -33.61-.33c-9.7 9.33-9.47 25.13.05 34.65l44.47 44.5h-236.15a24 24 0 0 0 -24 24 24 24 0 0 0 24 24h236.16l-44.9 44.9a24 24 0 0 0 33.94 33.95l85.44-85.41a24.66 24.66 0 0 0 0-34.91z" />
                    </g>
                  </svg>
                  {/* Text — mobile only */}
                  <span className="login-text-mobile d-md-none">Login</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Header;
